module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.companies), function(record) {
    return _c('div', {
      key: record.company.id
    }, [(!_vm.$auth.hasRole('COMPANY_ADMIN')) ? _c('div', {
      staticClass: "target-report-company",
      on: {
        "click": function($event) {
          record.showChildren = !record.showChildren
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(record.showChildren ? 'expand_less' : 'expand_more'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(record.company.name))])], 1) : _vm._e(), _vm._v(" "), _c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (record.showChildren),
        expression: "record.showChildren"
      }],
      staticClass: "datatable table table-crud elevation-1"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.period')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.defined')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.used')))])])]), _vm._v(" "), _c('tbody', _vm._l((record.items), function(item) {
      return _c('tr', {
        key: ((item.year) + "/" + (item.month))
      }, [_c('td', [_vm._v(_vm._s(((item.year) + "/" + (item.month))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.company.targets.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.targetUsage.length))])])
    }))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69963caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/LogicStorageReport/TargetsReport.vue
// module id = 1078
// module chunks = 1